module.exports = __webpack_public_path__ + "img/80.e2c25f17.png";